export default [
  {
    title: 'Dashboard',
    class: 'step-tour-freemium',
    icon: 'HomeIcon',
    route: 'dashboard',
    resource: 'menu',
    action: 'dashboard'
  },
  {
    title: 'menu-reports',
    icon: 'BarChartIcon',
    route: 'automatic-reports',
    resource: 'automatic-reports',
    action: 'list'
  },
  {
    title: 'menu-deliveries-create',
    svg: true,
    route: 'deliveries-create',
    resource: 'deliveries',
    action: 'create'
  },
  {
    title: 'menu-deliveries-list',
    route: 'deliveries-list',
    icon: 'ListIcon',
    resource: 'deliveries',
    action: 'list'
  },
  {
    title: 'menu-deliveries-flash',
    icon: 'ZapIcon',
    resource: 'menu',
    action: 'envia-flash',
    specialAccess: ['canAccessEnviaFlash'],
    children: [
      {
        title: 'menu-deliveries-flash-create',
        route: 'envia-flash',
        resource: 'envia-flash',
        action: 'create'
      },
      {
        title: 'menu-deliveries-flash-config',
        route: 'envia-flash-config',
        resource: 'envia-flash',
        action: 'config'
      }
    ]
  },
  {
    title: 'menu-returns',
    icon: 'CornerUpLeftIcon',
    resource: 'menu',
    action: 'returns',
    children: [
      {
        title: 'menu-returns-create',
        route: 'returns',
        resource: 'returns',
        action: 'create'
      },
      {
        title: 'menu-returns-list',
        route: 'returns-list',
        resource: 'returns',
        action: 'list'
      }
    ]
  },
  {
    title: 'menu-carrier',
    icon: 'TruckIcon',
    resource: 'menu',
    action: 'carriers',
    children: [
      {
        title: 'menu-courier-catalog',
        route: 'couriers-catalog',
        resource: 'carriers',
        action: 'carrier-client'
      },
      {
        title: 'menu-courier-code',
        route: {
          path: '/couriers/:id'
        },
        resource: 'carriers',
        action: 'carrier-client'
      }
    ]
  },
  {
    title: 'menu-pudos',
    icon: 'MapPinIcon',
    route: 'pudos',
    resource: 'pudos',
    action: 'list'
  },
  {
    title: 'menu-marketcenter',
    icon: 'ShoppingCartIcon',
    resource: 'menu',
    action: 'marketcenter',
    children: [
      {
        title: 'menu-marketcenter-canal',
        class: 'step-tour-freemium-2',
        route: 'marketcenter',
        resource: 'marketcenter',
        action: 'config'
      },
      {
        title: 'menu-marketcenter-deliveries',
        class: 'step-tour-freemium-3',
        route: 'marketcenter-deliveries',
        resource: 'marketcenter',
        action: 'deliveries'
      },
      {
        title: 'menu-marketcenter-products',
        route: 'marketcenter-products',
        resource: 'marketcenter',
        action: 'products'
      }
    ]
  },
  {
    title: 'menu-tickets',
    // icon: 'FileTextIcon',
    svg: true,
    resource: 'menu',
    action: 'tickets',
    children: [
      {
        title: 'menu-tickets-pending',
        route: 'tickets-pending',
        resource: 'tickets',
        action: 'pending'
      },
      {
        title: 'menu-tickets-panel',
        route: 'tickets-madagascar',
        resource: 'tickets',
        action: 'detail'
      }
    ]
  },
  {
    title: 'menu-materials',
    // icon: 'ArchiveIcon',
    svg: true,
    route: 'materials',
    resource: 'materials',
    action: 'list'
  },
  {
    title: 'menu-rules',
    svg: true,
    route: 'advanced-rules-list',
    resource: 'advanced-rules',
    action: 'list'
  },
  {
    title: 'menu-company-details',
    svg: true,
    route: {
      path: '/companies/:id'
    },
    resource: 'companies',
    action: 'details'
  },
  {
    title: 'menu-company-details-freemium',
    class: 'step-tour-freemium-4',
    icon: 'TabletIcon',
    route: {
      path: '/companies-freemium/:id'
    },
    resource: 'companies',
    action: 'details-freemium'
  },
  {
    title: 'menu-cash',
    icon: 'FileIcon',
    route: {
      path: '/recaudos/:id'
    },
    resource: 'recaudos',
    action: 'list'
  },
  {
    title: 'menu-pricing-tariff',
    // icon: 'DollarSignIcon',
    svg: true,
    route: 'tariff-calculator',
    resource: 'pricing',
    action: 'calculator'
  },
  {
    title: 'menu-support',
    svg: true,
    route: 'support',
    resource: 'support',
    action: 'info'
  },
  {
    title: 'menu-support-info-freemium',
    svg: true,
    route: 'support-freemium',
    resource: 'companies',
    action: 'details-freemium'
  },  
  {
    title: 'menu-billing-details',
    //icon: 'FileIcon',
    svg: true,
    route: {
      path: '/billing/:id'
    },
    resource: 'billing',
    action: 'details'
  },
  {
    title: 'menu-billing-connect',
    svg: true,
    route: 'auditor-connect',
    resource: 'billing',
    action: 'connect'
  },
  {
    title: 'menu-claims',
    icon: 'BookIcon',
    href: 'https://forms.gle/Nmu4HSadabAi1yUF6',
    resource: 'claims',
    action: 'form'
  }
  // {
  //   title: 'menu-cyber-form',
  //   svg: true,
  //   route: 'cyber-form',
  //   resource: 'menu',
  //   action: 'dashboard',
  //   shipperCountry: ['CL'],
  //   organizationCountry: ['CL'],
  //   organizationIdHidden: [1162, 7551] // 1162 Cenco Mkp, 7551 Walmart Mkp
  // }
]
